import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const TemplateActions = require('../../actions/TemplateActions');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import TemplateCreateInfoEditor from './TemplateCreateInfoEditor';

const propTypes = {
    template: PropTypes.object.isRequired,
    action: PropTypes.shape({
        id: PropTypes.string,
        error: PropTypes.object,
    }).isRequired,
};
const defaultProps = {};

const DEFAULT_CREATE_INFO_STRING = JSON.stringify({
    shortDesc: "",
    longDesc: "",
    howToPlaySteps: [],
    objectives: [],
    authoringSteps: [],
    assetTypes: [],
    demoLink: "",
    subtypes: [],
});

class TemplateListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actionID: null,
            public: this.props.template.public,
            allowAssignmentQla: this.props.template.allow_assignment_qla,
            allowMultiAssign: this.props.template.allow_multi_assign,
            create_info: this.props.template.create_info || DEFAULT_CREATE_INFO_STRING,
            error: null,
            uiErrors: {},
            actionSuccess: false,
            successMessage: "",
        };
        // refs
        this.displayName = React.createRef();
        this.asDisplayName = React.createRef();
        this.product = React.createRef();
        this.moduleId = React.createRef();
        this.editorUrl = React.createRef();
        this.templateUrl = React.createRef();
        this.icon = React.createRef();
        this.noChangesIcon = React.createRef();
        this.unpublishedChangesIcon = React.createRef();

        this.onPublicChanged = this.onPublicChanged.bind(this);
        this.onAllowAssignmentQlaChanged = this.onAllowAssignmentQlaChanged.bind(this);
        this.onAllowMultiAssignChanged = this.onAllowMultiAssignChanged.bind(this);
        this.onCreateInfoChanged = this.onCreateInfoChanged.bind(this);
        this.updateTemplateHandler = this.updateTemplateHandler.bind(this);
        // this.deleteTemplateHandler = this.deleteTemplateHandler.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.actionID === nextProps.action.id) {
            let updatedState;
            if (!!nextProps.action.error) {
                let uiErrors = {};
                if (nextProps.action.error.uiRefs) {
                    nextProps.action.error.uiRefs.forEach((ref) => {
                        uiErrors[ref] = true;
                    })
                }

                updatedState = {
                    actionID: null,
                    error: nextProps.action.error,
                    uiErrors: uiErrors,
                    actionSuccess: false, 
                    successMessage: '',
                };
            }
            else {
                updatedState = {
                    actionID: null,
                    error: null,
                    uiErrors: {},
                    actionSuccess: true,
                    successMessage: nextProps.action.message,
                };
            }

            this.setState(updatedState);
        }
    }

    onPublicChanged(e) {
        this.setState({ public: e.target.checked });
    }

    onAllowAssignmentQlaChanged(e) {
        this.setState({ allowAssignmentQla: e.target.checked });
    }

    onAllowMultiAssignChanged(e) {
        this.setState({ allowMultiAssign: e.target.checked });
    }

    onCreateInfoChanged(create_info) {
        this.setState({ create_info: create_info });
    }

    updateTemplateHandler() {
        const actionID = uuid.v4();
        this.setState({actionID: actionID}, () => {
            TemplateActions.updateTemplate(actionID, {
                templateId: this.props.template.id,
                displayName: this.displayName.current.value,
                asDisplayName: this.asDisplayName.current.value,
                product: this.product.current.value,
                moduleId: this.moduleId.current.value,
                editorUrl: this.editorUrl.current.value,
                templateUrl: this.templateUrl.current.value,
                icon: this.icon.current.value,
                noChangesIcon: this.noChangesIcon.current.value,
                unpublishedChangesIcon: this.unpublishedChangesIcon.current.value,
                public: this.state.public,
                allowAssignmentQla: this.state.allowAssignmentQla,
                allowMultiAssign: this.state.allowMultiAssign,
                createInfo: this.state.create_info, // Note: 'createInfo' is used for the action params, but the server uses 'create_info'
            });
        });
    }

    /*deleteTemplateHandler() {
        TemplateActions.deleteTemplate({
            templateID: this.props.template.id
        });
    }*/

    render() {
        const template = this.props.template;

        return (
            <Card body bg="light">
                {(this.state.actionSuccess) && <SuccessBox message={this.state.successMessage}/>}
                <ErrorBox error={this.state.error} />

                <Form>
                    <Form.Group controlId={"admin-tmpl-disp-name-"+template.id}>
                        <Form.Label>Display Name</Form.Label>
                        <Form.Control
                            ref={this.displayName}
                            defaultValue={template.name}
                            isInvalid={this.state.uiErrors['displayName']}
                        />
                    </Form.Group>
                    <Form.Group controlId={"admin-tmpl-as-disp-name-"+template.id}>
                        <Form.Label>Assignment Service Display Name</Form.Label>
                        <Form.Control
                            ref={this.asDisplayName}
                            defaultValue={template.as_display_name}
                            isInvalid={this.state.uiErrors['asDisplayName']}
                        />
                    </Form.Group>
                    <Form.Group controlId={"admin-tmpl-product-"+template.id}>
                        <Form.Label>Product</Form.Label>
                        <Form.Control
                            ref={this.product}
                            defaultValue={template.product}
                            isInvalid={this.state.uiErrors['product']}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-module-id-"+template.id}>
                        <Form.Label>Module ID</Form.Label>
                        <Form.Control
                            ref={this.moduleId}
                            isInvalid={this.state.uiErrors['moduleID']}
                            defaultValue={template.module_id}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-editor-url-"+template.id}>
                        <Form.Label>Editor URL</Form.Label>
                        <Form.Control
                            ref={this.editorUrl}
                            isInvalid={this.state.uiErrors['editUrl']}
                            defaultValue={template.editor_url}
                        />
                    </Form.Group>

                    <Form.Group
                        controlId={"admin-tmpl-tmpl-url-"+template.id}
                    >
                        <Form.Label>Template URL</Form.Label>
                        <Form.Control
                            ref={this.templateUrl}
                            isInvalid={this.state.uiErrors['templateUrl']}
                            defaultValue={template.template_url}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-icon-"+template.id}>
                        <Form.Label>Icon</Form.Label>
                        <Form.Control
                            ref={this.icon}
                            isInvalid={this.state.uiErrors['icon']}
                            defaultValue={template.icon}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-nc-icon-"+template.id}>
                        <Form.Label>No Changes Icon</Form.Label>
                        <Form.Control
                            ref={this.noChangesIcon}
                            isInvalid={this.state.uiErrors['noChangesIcon']}
                            defaultValue={template.no_changes_icon}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-upc-icon-"+template.id}>
                        <Form.Label>Unpublished Changes Icon</Form.Label>
                        <Form.Control
                            ref={this.unpublishedChangesIcon}
                            defaultValue={template.unpublished_changes_icon}
                            isInvalid={this.state.uiErrors['unpublishedChangesIcon']}
                        />
                    </Form.Group>

                    <TemplateCreateInfoEditor
                        className="margin-bottom-md"
                        template={template}
                        create_info={this.state.create_info}
                        onChange={this.onCreateInfoChanged}
                    />

                    <Form.Group controlId={"admin-tmpl-public-"+template.id}>
                        <Form.Check
                            inline
                            label="Public"
                            checked={this.state.public}
                            onChange={this.onPublicChanged}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-aaqla-"+template.id}>
                        <Form.Check
                            inline
                            label="Allow Assignment QLA"
                            checked={this.state.allowAssignmentQla}
                            onChange={this.onAllowAssignmentQlaChanged}
                        />
                    </Form.Group>

                    <Form.Group controlId={"admin-tmpl-ama-"+template.id}>
                        <Form.Check
                            inline
                            label="Allow Multi-Assign"
                            checked={this.state.allowMultiAssign}
                            onChange={this.onAllowMultiAssignChanged}
                        />
                    </Form.Group>                 

                    <Button onClick={this.updateTemplateHandler.bind(this, template.id)}>
                        Update Template
                    </Button>
                    {/*<Button variant="danger" onClick={_this.deleteTemplateHandler.bind(_this, template.id)}>
                        Delete Template
                    </Button>*/}
                </Form>
            </Card>
        );
    }
}

TemplateListing.propTypes = propTypes;
TemplateListing.defaultProps = defaultProps;

export default TemplateListing;